var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function camelToDash(str) {
    if (str != str.toLowerCase()) {
        str = str.replace(/[A-Z]/g, function (m) { return '-' + m.toLowerCase(); });
    }
    return str;
}
export function generateStyleFromCtx(ctx) {
    return Object.entries(ctx.theme).reduce(function (acc, _a) {
        var _b;
        var _c;
        var k = _a[0], v = _a[1];
        return __assign(__assign({}, acc), (_b = {}, _b["--" + camelToDash(k)] = v, _b["--" + camelToDash(k + "RgbComponents")] = ((_c = v.match(/rgb\((\d+, \d+, \d+)\)/)) === null || _c === void 0 ? void 0 : _c[1]) || undefined, _b));
    }, {
        padding: ctx.bodyPadding.map(function (p) { return p + "px"; }).join(' '),
    });
}
//# sourceMappingURL=index.js.map